<div class="bff-modal-form">
  <div class="modal-header">
    <h5 class="modal-title">{{ header }}</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('close')"></button>
  </div>
  <div class="modal-body">
    <ng-container *ngIf="contentType === 'html'; else textContent">
      <div [innerHTML]="content" class="bff-text"></div>
    </ng-container>
    <ng-template #textContent>
      <p class="bff-text">{{ content }}</p>
    </ng-template>
  </div>
  <div class="modal-footer bff-button-container">
    <ng-content select="[alert-footer]"></ng-content>
    <button type="button" class="bff-button bff-button--primary" (click)="modal.close('ok')">OK</button>
  </div>
</div>